import { useEffect, useState } from "react";
import { sendTagOnGeolocationError } from "app/utils/analytics";

export default ({ enable }) => {
	const [latitude, setLatitude] = useState();
	const [longitude, setLongitude] = useState();

	useEffect(() => {
		if (enable) {
			if ("geolocation" in navigator) {
				navigator.geolocation.getCurrentPosition(
					position => {
						setLatitude(position.coords.latitude);
						setLongitude(position.coords.longitude);
					},
					error => {
						sendTagOnGeolocationError({ code: error.code });
					},
					{
						enableHighAccuracy: true,
						maximumAge: 3600000,
						timeout: 30000,
					}
				);
			} else {
				sendTagOnGeolocationError({ code: 4 });
			}
		}
	}, [enable]);

	return {
		latitude,
		longitude,
	};
};
